// extracted by mini-css-extract-plugin
export var container = "_8x-0";
export var error = "_8x-9";
export var label = "_8x-5";
export var light = "_8x-6";
export var md = "_8x-3";
export var sm = "_8x-2";
export var thin = "_8x-8";
export var thinBold = "_8x-7";
export var vertical = "_8x-4";
export var xs = "_8x-1";